import { useState } from "react";
import { Col, Divider, Input, Row } from "antd";
import "./dpoMyChecklist.css";
import { Collapse, Empty, Pagination, Tooltip as AntTooltip } from "antd";

//import icons
import { ReactComponent as ConfirmIcon } from "../../assets/waiting-for-approval.svg";
import { ReactComponent as Bin } from "../../assets/bin.svg";
import { ReactComponent as SubmitIcon } from "../../assets/submit.svg";
import { ReactComponent as SubmitIcon2 } from "../../assets/submit2.svg";
import { ReactComponent as Dots } from "../../assets/threeDots.svg";
import { ReactComponent as Arrow } from "../../assets/vector.svg";
import { useNavigate } from "react-router-dom";
import { Button } from "antd";
import dayjs from "dayjs";
import { Upload } from "../../components";
import { isString, set } from "lodash";
import { isEmpty } from "lodash";
import { DatePicker, Form, Select, Modal, Checkbox, Spin, Popover } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useSelector, useDispatch } from "react-redux";
import { mainCategoryOptions } from "../../data/data";
import { useEffect } from "react";
import { renderOptions } from "../../util/basicRenders";
import { ReactComponent as InfoIcon } from "../../assets/info.svg";
import ColoredBulletLink from "../../components/shared/ColoredBulletLink";

import {
  updateObligation,
  assignUser,
  deleteObligation,
  createMessage,
  getAllMessages
} from "../../store/obligations/actions";
// import { sendEmail } from "../../store/email/actions";

// import { assignToUserMessage, actionChangeMessage } from "../../util/emailTemplates";
import MessagesList from "../../components/messagesList/MessagesList";
import { setVariable } from "../../store/forms/actions";

// myTask is false when we want the dpo user obligations and true when we want the assigned user obligations
const MainObligations = ({
  usersData = [],
  obligationsInCategory = [],
  handleChangeObl,
  handleClearMessage,
  currentPage,
  setCurrentPage,
  displayedItems,
  Loading,
  setChecked = () => {},
  panelStyle,
  obligations,
  myTask,
  organization,
  selectedObligations = [],
  setSelectedObligations = () => {},
  scrolled,
  setScrolled
}) => {
  const { Panel } = Collapse;
  const dispatchito = useDispatch();
  const dateFormat = "DD MMM YYYY";

  //create login link
  const loginLink = `http://${process.env.REACT_APP_FILE_HOST}/regcom/login`;

  const laws = useSelector(state => state.laws.laws);
  const targetId = useSelector(state => state.obligations.navigateId);
  const user = useSelector(state => state.user);
  const documents = useSelector(state => state.documents?.mainObligations);
  const messages = useSelector(state => state.obligations.messages);
  const configurations = useSelector(state => state.forms.appConfig.pageList);
  const originalObligations = useSelector(
    state => state.obligations.obligations
  );
  const [checkPage, setCheckPage] = useState(true);
  const [elementId, setElementId] = useState("");
  const [check, setCheck] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [activeKey, setActiveKey] = useState("");
  const [checkScroll, setCheckScroll] = useState(true);
  const [currentPageSetted, setCurrentPageSetted] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedObligation, setSelectedObligation] = useState({});
  const navigate = useNavigate();

  const displayedLaws = displayedItems
    ? laws?.filter(law =>
        displayedItems.map(item => item.law_id).includes(law._id)
      )
    : [];

  if (targetId) {
    const startPage = Math.ceil(
      (obligations?.findIndex(ob => ob._id === targetId) + 1) / 5
    );
    const activeNum =
      Math.ceil((obligations?.findIndex(ob => ob._id === targetId) + 1) / 5) *
        5 -
      obligations?.findIndex(ob => ob._id === targetId);

    if (startPage !== 0 && checkPage) {
      setCheckPage(false);
      setCurrentPage(startPage);
      if (activeNum === 1) {
        setActiveKey(4);
      } else if (activeNum === 2) {
        setActiveKey(3);
      } else if (activeNum === 3) {
        setActiveKey(2);
      } else if (activeNum === 4) {
        setActiveKey(1);
      } else {
        setActiveKey(0);
      }
    }
  } else {
    setScrolled(true);
  }
  useEffect(() => {
    if (targetId) {
      setLoadingSubmit(true);
    }
  }, []);

  useEffect(() => {
    if (!checkPage) {
      setLoadingSubmit(false);
    }
  }, [checkPage]);

  useEffect(() => {
    const targetElement = document.getElementById(targetId);
    if (targetElement) {
      targetElement.scrollIntoView({ behavior: "smooth" });
      dispatchito({
        type: "CLEAR_NAVIGATE_ID"
      });
      setScrolled(true);
    }
  }, [targetId, currentPage, Loading, loadingSubmit]);

  useEffect(() => {
    setActiveKey("");
  }, [currentPage]);

  // Handle pagination change
  const handlePageChange = page => {
    setCurrentPage(page);
    setChecked(false);
    setSelectedObligations([]);
    setLoadingSubmit(true);
    setActiveKey("");
    //setLoading true
  };

  //useEffect setLoading false when page changes
  useEffect(() => {
    setLoadingSubmit(false);
  }, [currentPage]);

  const onCheckboxChange = (event, item, index) => {
    if (selectedObligations?.includes(item)) {
      const updatedSelectedObligations = selectedObligations?.filter(
        selectedItem => selectedItem !== item
      );
      setSelectedObligations(updatedSelectedObligations);
    } else {
      setSelectedObligations([...selectedObligations, item]);
    }
  };

  const getUserName = id => {
    if (id !== "0") {
      const userId = originalObligations?.find(
        item => item._id === id
      )?.user_id;
      const theUser = usersData?.find(u => u._id === userId);
      return `${theUser?.firstName} ${theUser?.lastName}`;
    } else return "-";
  };

  // console.log("MESSAGES:",messages);

  const handleEnterMessage = (id, message) => {
    // setLoadingSubmit(true);
    dispatchito(
      createMessage(user, id, message, organization, check => {
        setElementId(id);
        setCheck(check);
        // setLoadingSubmit(false);
      })
    );
    handleClearMessage({
      event: "",
      id: id,
      key: "messages",
      type: "text"
    });
    // dispatchito(getAllMessages(user, organization));
  };

  const handleSubmit = async ({ obligation, id }) => {
    setLoadingSubmit(true);
    const formData = new FormData();
    formData.append("description", obligation.description);
    formData.append("dueDate", obligation.dueDate ? obligation.dueDate : "");
    formData.append("assessment", obligation.assessment);
    formData.append("comments", obligation.comments);
    formData.append("action", obligation.action);
    formData.append("user_id", obligation.user_id);

    // if (obligation.files) {
    //   console.log("files:",obligation.files);
    //   Object.values(obligation.files).forEach((file, index) => {
    //     formData.append("files", file);
    //   });
    // }

    dispatchito(
      updateObligation({
        obligation,
        formData,
        user,
        callback: check => {
          setElementId(obligation._id);
          setCheck(check);
          // setLoadingSubmit(false);
        },
        emailCallback: recipients => {
          // if (isEmpty(recipients) || !Array.isArray(recipients)) return;
          // const law = laws?.find(law => law._id === obligation.law_id)
          // for (const recipient of recipients) {
          //   console.debug("sending to ", recipient?.email)
          //   dispatchito(
          //     sendEmail({
          //       user,
          //       to: [recipient?.email],
          //       cc: [],
          //       subject: `${
          //         recipient?.company ? recipient.company + " - " : ""
          //       }Action Change`,
          //       message: actionChangeMessage(obligation, recipient, false, law),
          //       isHtmlMessage: true
          //       // message: 'HELLO text',
          //       // isHtmlMessage: false,
          //     })
          //   );
          // }
        }
      })
    );
    // dispatchito(
    //   sendEmail({
    //     user,
    //     to: [
    //       "odysseas.kouloukythas@gr.gt.com",
    //       "odysseas.kouloukythas@gr.gt.com",
    //     ],
    //     cc: [
    //       "odysseas.kouloukythas@gr.gt.com",
    //     ],
    //     subject: 'Updated Main Obligations',
    //     message: `<p style="color: #4F4F4F;margin: 12px 0">User <strong>${user.firstName + ' ' + user.lastName}</strong> updated Obligation.</p>`,
    //     isHtmlMessage: true,
    //     // message: 'HELLO text',
    //     // isHtmlMessage: false,
    //   }));
  };

  const unassignUser = ({ item }) => {
    setLoadingSubmit(true);
    dispatchito(
      assignUser({
        newItem: {
          _id: item._id,
          user_id: "0"
        },
        user,
        organizationId: organization,
        callback: check => {
          setElementId(item._id);
          setCheck(check);
        }
      })
    );
  };

  const handleAssign = async ({ item }) => {
    setLoadingSubmit(true);
    const newItem = { ...item };
    newItem.isAssigned = item.user_id !== "0";
    dispatchito(
      assignUser({
        newItem,
        user,
        organizationId: organization,
        callback: check => {
          setElementId(newItem._id);
          setCheck(check);
          // const userAssigned = usersData.find(
          //   item => item._id === newItem.user_id
          // );
          // const law = laws?.find(law => law._id === item.law_id)
          // dispatchito(
          //   sendEmail({
          //     user,
          //     to: [userAssigned.email],
          //     cc: [],
          //     subject: 'Assigned Main Obligation',
          //     message: assignToUserMessage(newItem, user, false, law),
          //     isHtmlMessage: true,
          //     // message: 'HELLO text',
          //     // isHtmlMessage: false,
          //   }));
        }
      })
    );
  };

  const getCategoryLabel = mainCategory => {
    let cat = mainCategoryOptions?.filter(item => item.value == mainCategory);
    return cat && !isEmpty(cat) ? cat[0].label : "";
  };

  useEffect(() => {
    if (elementId && check) {
      setCheck(false);
      setCurrentPage(
        Math.ceil((obligations.findIndex(ob => ob._id === elementId) + 1) / 5)
      );

      const activeNum =
        Math.ceil((obligations.findIndex(ob => ob._id === elementId) + 1) / 5) *
          5 -
        obligations.findIndex(ob => ob._id === elementId);

      if (activeNum === 1) {
        setActiveKey(4);
      } else if (activeNum === 2) {
        setActiveKey(3);
      } else if (activeNum === 3) {
        setActiveKey(2);
      } else if (activeNum === 4) {
        setActiveKey(1);
      } else {
        setActiveKey(0);
      }
      setCheck(false);
      setCurrentPageSetted(true);
      setLoadingSubmit(false);
    }
  }, [check, elementId]);

  const content = item => (
    <div id="obligations-more-actions-list">
      <a
        id="obl-history-button"
        onClick={() => {
          dispatchito(setVariable({ key: "historySearch", value: item?.code }));
          navigate(`/audit`);
        }}
      >
        <span style={{ marginLeft: "-10.625rem" }}>History</span>
      </a>
    </div>
  );

  const selectObligation = async value => {
    setSelectedObligation(value);
  };

  useEffect(() => {
    if (currentPageSetted) {
      document
        .getElementById(elementId)
        ?.scrollIntoView({ behavior: "smooth" });
      setCurrentPageSetted(false);
    }
  }, [currentPageSetted]);

  return Loading || loadingSubmit ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "3.125rem"
      }}
    >
      <Spin size="large" />
    </div>
  ) : (
    <div>
      <Collapse
        className="my-check-list"
        accordion
        expandIconPosition="start"
        defaultActiveKey={activeKey}
        // activeKey={activeKey}
        expandIcon={({ isActive }) =>
          isActive ? (
            <Button
              id="seeLess-button"
              className="icon-center  expand-icon-obligations"
              style={{
                fontSize: "0.875rem",
                position: "absolute",
                bottom: "5.625rem",
                left: "-0.5rem",
                zIndex: "10"
              }}
              type="default"
              icon={
                <span
                  id="greater"
                  style={{
                    transform: "rotate(0.75turn)",
                    // display: "inline-flex",
                    marginLeft: "0.2rem",
                    marginTop: "-0.1rem",
                    width: "100%"
                  }}
                >
                  <SubmitIcon />
                </span>
              }
            ></Button>
          ) : (
            <Button
              className="icon-center  expand-icon-obligations"
              id="main-obligations-icon-center-see-more-button-expand-icon-obligations"
              style={{
                fontSize: "0.875rem",
                position: "absolute",
                bottom: "5.625rem",
                left: "-0.5rem",
                width: "6.188rem",
                zIndex: "10",
                border: "none"
              }}
              type="default"
              icon={
                <span
                  id="greater"
                  style={{
                    transform: "rotate(0.25turn)",
                    // display: "inline-flex",
                    marginLeft: "-0.05rem",
                    marginTop: "0.2rem",
                    width: "100%"
                  }}
                >
                  <SubmitIcon />
                </span>
              }
            ></Button>
          )
        }
      >
        {!isEmpty(displayedItems) ? (
          displayedItems.map((item, index) => (
            <Panel
              id={`${item._id}`}
              style={panelStyle}
              collapsible="icon"
              showArrow={true}
              header={
                <Form
                  wrapperCol={{
                    span: 24
                  }}
                  className="form-row-height"
                >
                  <Row
                    className="row-height-white"
                    gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
                  >
                    {/* <Col span={1}>
                      <Form.Item id="ob_id">
                        <TextArea
                          id={`ob_id_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 3 }}
                          value={itemsPerPage * (currentPage - 1) + index + 1}
                        ></TextArea>
                      </Form.Item>
                    </Col> */}
                    {user.role !== "assignedUser" && (
                      <Form.Item id="ob_checkbox">
                        <Checkbox
                          checked={selectedObligations.includes(item)}
                          id="ob-page-checkbox"
                          style={{
                            position: "absolute",
                            left: "-3.05rem",
                            top: "5.313rem"
                          }}
                          onChange={e => onCheckboxChange(e, item, index)}
                          disabled={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver"
                          }
                        />
                      </Form.Item>
                    )}
                    <Col></Col>{" "}
                    {/* empty column so see more button has space next to law */}
                    <Col
                      // span={2}
                      className="checklist-title-col"
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                      <Form.Item id="ob_law_title">
                        <TextArea
                          id={`ob_law_title_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 5 }}
                          value={
                            (
                              displayedLaws?.find(
                                law => law._id === item.law_id
                              ) || {}
                            ).title
                          }
                        ></TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={3}
                      className="checklist-category-col"
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                    >
                      <Form.Item id="ob_cat">
                        <TextArea
                          id={`ob_cat_${index}`}
                          bordered={false}
                          disabled
                          value={getCategoryLabel(item.mainCategory)}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          style={{ padding: "0.313rem 0" }}
                        ></TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                      className="obl-art-par-column checklist-article-col"
                    >
                      <Form.Item id="ob_article">
                        <TextArea
                          id={`ob_article_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          value={
                            item.article !== "undefined" ? item.article : "-"
                          }
                        ></TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                      className="obl-art-par-column checklist-paragraph-col"
                    >
                      <Form.Item id="ob_paragraph">
                        <TextArea
                          id={`ob_paragraph_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          value={
                            item.paragraph !== "undefined"
                              ? item.paragraph
                              : "-"
                          }
                        ></TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      style={{ paddingLeft: 0, paddingRight: 0 }}
                      className="obl-art-par-column checklist-category-col"
                    >
                      <Form.Item id="ob_id">
                        <TextArea
                          id={`ob_id_${index}`}
                          className="no-action"
                          bordered={false}
                          autoSize={{ minRows: 1, maxRows: 4 }}
                          value={item?.code ?? "-"}
                        ></TextArea>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={7}
                      className="obl-description-column checklist-obligation-col"
                    >
                      <div>
                        <AntTooltip
                          title={() => (
                            <div style={{ whiteSpace: "pre-wrap" }}>
                              {item?.description}
                            </div>
                          )}
                          arrow={false}
                          overlayClassName="description-tooltip"
                          mouseEnterDelay={0.5}
                          placement="bottomLeft"
                        >
                          <Form.Item id="ob_desc">
                            <TextArea
                              id={`ob_desc_${index}`}
                              // span={4}
                              disabled={true}
                              bordered={false}
                              value={item.description}
                              autoSize={{ minRows: 1, maxRows: 6 }}
                              style={{ fontSize: "0.75rem" }}
                              onChange={value =>
                                handleChangeObl({
                                  event: value,
                                  id: item._id,
                                  key: "description",
                                  type: "text"
                                })
                              }
                            ></TextArea>
                          </Form.Item>
                        </AntTooltip>
                      </div>
                      <div
                        className="infoPlacement"
                        style={{ marginLeft: "1rem", marginTop: "-0.5rem" }}
                      >
                        {item?.info && (
                          <AntTooltip
                            title={() => (
                              <div style={{ whiteSpace: "pre-wrap" }}>
                                {item?.info}
                              </div>
                            )}
                            arrow={false}
                            overlayClassName="description-tooltip"
                            mouseEnterDelay={0.5}
                            placement="bottomLeft"
                          >
                            <InfoIcon
                              style={{
                                height: "13px",
                                width: "13px",
                                marginLeft: "-5px"
                              }}
                            />
                            <text
                              style={{
                                fontSize: "11px",
                                color: "#725798",
                                marginLeft: "5px"
                              }}
                            >
                              Obligation Info
                            </text>
                          </AntTooltip>
                        )}
                      </div>
                    </Col>
                    <Col
                      // span={3}
                      className="obl-select-col obl-action-col checklist-action-col"
                    >
                      <Form.Item id="ob_action">
                        <Select
                          className="action-select"
                          id={`ob_action_${index}`}
                          onChange={value =>
                            handleChangeObl({
                              event: value,
                              id: item._id,
                              key: "action",
                              type: "select"
                            })
                          }
                          value={item.action}
                          disabled={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            (myTask && item?.assessment === "Compliant")
                          }
                        >
                          <Select.Option value="Pending">Pending</Select.Option>
                          <Select.Option value="Completed">
                            Completed
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      // span={3}
                      className="obl-select-col obl-assessment-col checklist-assessment-col"
                    >
                      <Form.Item id="ob_as">
                        <Select
                          virtual={false}
                          id={`ob_as_${index}`}
                          className="assessment-select"
                          popupClassName="assessment-dropdown"
                          onChange={value =>
                            handleChangeObl({
                              event: value,
                              id: item._id,
                              key: "assessment",
                              type: "select"
                            })
                          }
                          value={item.assessment}
                          disabled={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            user.role === "assignedUser"
                          }
                        >
                          <Select.Option value="Partially">
                            <span className="assessment-tag-option partially-compliant">
                              Partially Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="Compliant">
                            <span className="assessment-tag-option compliant">
                              Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="Non-Compliant">
                            <span className="assessment-tag-option non-compliant">
                              Non Compliant
                            </span>
                          </Select.Option>
                          <Select.Option value="na">
                            <span className="assessment-tag-option na">
                              N/A
                            </span>
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col
                      style={{ paddingLeft: 0 }}
                      className="checklist-due-col"
                    >
                      <Form.Item id="ob_due">
                        <DatePicker
                          // style={{width:"9.813rem"}}
                          id={`ob_due_${index}`}
                          bordered={!myTask}
                          className={`due-date-picker ${
                            myTask ? " no-action" : ""
                          }${
                            (user.role === "corporateComplianceObserver" ||
                              user.role === "groupComplianceObserver" ||
                              myTask) &&
                            !item?.dueDate
                              ? ""
                              : ""
                          }`}
                          allowClear={false}
                          format={dateFormat}
                          disabled={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver"
                          }
                          placeholder={
                            user.role === "corporateComplianceObserver" ||
                            user.role === "groupComplianceObserver" ||
                            myTask
                              ? "-"
                              : "Select Date"
                          }
                          value={
                            isString(item.dueDate)
                              ? dayjs(item.dueDate)
                              : item.dueDate
                          }
                          onChange={(date, dateString) =>
                            handleChangeObl({
                              event: date,
                              id: item._id,
                              key: "dueDate",
                              type: "date"
                            })
                          }
                        ></DatePicker>
                      </Form.Item>
                    </Col>
                    {/* <Col span={3}>
                      <Form.Item className="mt-2" id="ob_com">
                        <TextArea
                          id={`ob_com_${index}`}
                          className="mb-2"
                          onChange={value =>
                            handleChangeObl({
                              event: value,
                              id: item._id,
                              key: "comments",
                              type: "text"
                            })
                          }
                          value={
                            item.comments == "undefined" ? "" : item.comments
                          }
                          autoSize={{ minRows: 5, maxRows: 6 }}
                        ></TextArea>
                        <div
                          id={`ob_save_btn_${index}`}
                          className="savebutton"
                          onClick={() =>
                            handleSubmit({ obligation: item, id: item._id })
                          }
                        >
                          Αποθήκευση
                        </div>
                      </Form.Item>
                    </Col> */}
                    <Col
                      // span={2}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        paddingLeft: 0,
                        paddingRight: "30px"
                      }}
                      className="checklist-submit-col"
                    >
                      {/* <div
                        id={`ob_save_btn_${index}`}
                        className="savebutton"
                        onClick={() =>
                          handleSubmit({ obligation: item, id: item._id })
                        }
                      >
                        > Submit
                      </div> */}
                      {user.role !== "corporateComplianceObserver" &&
                        user.role !== "groupComplianceObserver" && (
                          <>
                            <Button
                              id={`ob_save_btn_${index}`}
                              type="primary"
                              className="checklist-submit"
                              style={{ marginBottom: "1.438rem" }}
                              onClick={() =>
                                handleSubmit({ obligation: item, id: item._id })
                              }
                            >
                              Submit
                              <span
                                id="greater"
                                style={{
                                  display: "inline-flex",
                                  marginLeft: "0.4rem"
                                }}
                              >
                                <SubmitIcon2 />
                              </span>
                            </Button>
                            {Object.values(
                              Object.fromEntries(
                                Object.entries(configurations)?.filter(
                                  ([key, values]) =>
                                    key === user.role &&
                                    values.includes("audit")
                                )
                              )
                            ).length !== 0 && (
                              <Popover
                                placement="bottomRight"
                                overlayClassName="custom-popover"
                                content={content(item)}
                                arrow={false}
                                trigger="click"
                              >
                                <a
                                  className="three-dots"
                                  style={{
                                    position: "absolute",
                                    left: "5.5rem",
                                    bottom: "1.438rem",
                                    border: "none"
                                  }}
                                  onClick={() => selectObligation(item)}
                                >
                                  <Dots />
                                </a>
                              </Popover>
                            )}
                          </>
                        )}
                    </Col>
                  </Row>
                </Form>
              }
              key={index}
            >
              {/* form titles */}
              <Row
                className="obligations-list-second-row-headers"
                gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
              >
                <Col
                  // span={7}
                  style={{
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left"
                  }}
                  className="checklist-owner-col-title"
                >
                  <span
                    className="title-style"
                    id="main-obligations-title-style-1"
                    style={{ marginLeft: "0.625rem" }}
                  >
                    Owner
                  </span>
                </Col>

                <Col
                  className="checklist-comments-col-title"
                  // span={myTask ? 4 : 4}
                  style={{
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left"
                  }}
                >
                  <span
                    className="title-style"
                    id="main-obligations-title-style-2"
                  >
                    Comments
                  </span>
                </Col>

                <Col
                  // span={myTask ? 8 : 10}
                  style={{
                    textAlign: "left",
                    display: "flex",
                    justifyContent: "left",
                    alignItems: "left"
                  }}
                  className="checklist-docs-col-title"
                  id="main-obligations-checklist-docs-col"
                >
                  <span
                    className="title-style"
                    id="main-obligations-title-style-3"
                  >
                    Supporting Documents
                  </span>
                </Col>
              </Row>
              <Form
                wrapperCol={{
                  span: 24
                }}
                layout="vertical"
                className="form-row-height"
                id="main-obligations-form-row-height"
              >
                <Row
                  className="row-height-gray"
                  id="main-obligations-row-height-gray"
                  gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}
                  style={{paddingBottom: '20px'}}
                >
                  {/* <Col className="ml-1" span={4}>
                    <Form.Item id="ob_freq">
                      <span>Frequency</span>
                      <Select id={`ob_freq_${index}`} className="mb-1"></Select>
                      <span>Send me a notification</span>
                      <Row gutter={{ xs: 8, sm: 12, md: 24, lg: 22 }}>
                        <Col span={9}>
                          <Select id={`ob_notif_num_${index}`}></Select>
                        </Col>
                        <Col span={15}>
                          <Select id={`ob_notif_metric_${index}`}></Select>
                        </Col>
                      </Row>
                    </Form.Item>
                  </Col> */}
                  <Col
                    className="checklist-owner-col"
                    id="main-obligations-checklist-owner-col"
                    span={5}
                  >
                    <Form.Item className="mt-0" id="ob_own" style={{marginBottom: "0"}}>
                      <div
                        style={{ marginTop: "-6.25rem"}}
                        className={
                          user.role === "assignedUser"
                            ? "owner-tag-obl"
                            : "owner-tag-obl mt-05"
                        }
                      >
                        {item?.isAssigned ? (
                          <div style={{ marginTop: "1rem" }}>
                            <ColoredBulletLink
                              text={
                                usersData && item?._id && getUserName(item._id)
                              }
                              // obligationID={item._id}
                              unassign={() => unassignUser({ item })}
                              allowClear={[
                                "assignedUser",
                                "corporateComplianceAssessor",
                                "groupComplianceAssessor"
                              ].includes(user.role)}
                            />
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                      <Select
                        // dropdownStyle={{maxHeight:"17rem"}}
                        virtual={false}
                        id={`ob_own_${index}`}
                        className="assign-select"
                        showSearch
                        allowClear
                        listHeight={250}
                        placeholder="Select..."
                        filterOption={false}
                        onSearch={setSearchValue}
                        disabled={user.role.includes("Observer")}
                        onChange={value =>
                          handleChangeObl({
                            event: value ?? "0",
                            id: item?._id,
                            key: "user_id",
                            type: "select"
                          })
                        }
                        value={
                          usersData &&
                          !isEmpty(usersData) &&
                          Array.isArray(usersData) &&
                          usersData.length > 0 &&
                          item.user_id &&
                          usersData
                            ?.filter(b => b._id === item.user_id)
                            .map(b => `${b?.firstName} ${b?.lastName}`)
                        }
                      >
                        {renderOptions(searchValue, usersData)}
                      </Select>
                      {user.role !== "corporateComplianceObserver" &&
                        user.role !== "groupComplianceObserver" && (
                          <div
                            id={`assign_btn_${index}`}
                            className="assign-button assign-button-main"
                            onClick={() => handleAssign({ item })}
                          >
                            {!item?.isAssigned ? "Assign" : "Reassign"}
                          </div>
                        )}
                    </Form.Item>
                  </Col>
                  <Col
                    // span={9}
                    className="checklist-comments-col"
                    id="main-obligations-checklist-comments-col"
                    style={{marginLeft: '0.6rem'}}
                  >
                    <Form.Item
                      className="mt-0 mb-0"
                      id="ob_com"
                      style={{ marginBottom: "0" }}
                    >
                      <div className="listcontainer">
                        <MessagesList
                          messages={messages}
                          item_id={item._id}
                          user={user}
                        />
                      </div>
                      <Input
                        style={{
                          backgroundColor: "#FAFAFF",
                          // marginLeft: "10px",
                          // position: "absolute",
                          // left: "0px",
                          // top: "200px",
                          borderTopLeftRadius: 'unset',
                          borderTopRightRadius: 'unset',
                        }}
                        onChange={value =>
                          handleChangeObl({
                            event: value,
                            id: item._id,
                            key: "messages",
                            type: "text"
                          })
                        }
                        className="message-input"
                        value={item?.messages}
                        placeholder="Make a new comment.."
                        onPressEnter={() =>
                          item.messages &&
                          handleEnterMessage(item?._id, item?.messages)
                        }
                        suffix={
                          <Button
                            style={{
                              backgroundColor: "#CDCDCD",
                              width: "22px",
                              height: "22px",
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              border: "none",
                              padding: "0",
                              cursor: "pointer"
                            }}
                            onClick={() =>
                              handleEnterMessage(item?._id, item?.messages)
                            }
                          >
                            <Arrow />
                          </Button>
                        }
                      />
                    </Form.Item>
                  </Col>

                  <Col
                    // span={10}
                    className="mt-0 checklist-docs-col"
                    id="main-obligations-mt-2-ml-2-checklist-docs-col"
                    style={{ paddingLeft: 0, paddingRight: 0, marginLeft: "0.4rem" }}
                  >
                    <Upload
                      multiple
                      item={{
                        fileCode: "mainObl",
                        required: true,
                        fileAccepts: ".pdf",
                        fileLimit: 30,
                        files: documents?.[item._id],
                        multiple: true
                      }}
                      group={"mainObligations"}
                      id={item._id}
                      obligation_id={item._id}
                      parent_id={item.parent_id}
                      organization={item.organization}
                      obligations={obligations}
                      accept={".pdf"}
                      style={{
                        marginTop: "2px",
                        overflowY: "auto",
                        width: "100%"
                      }}
                      disabled={
                        user.role === "corporateComplianceObserver" ||
                        user.role === "groupComplianceObserver"
                      }
                    />
                  </Col>
                </Row>
              </Form>
            </Panel>
          ))
        ) : (
          <Empty
            className="mt-12"
            id="main-obligations-empty-mt-12"
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={
              <>
                <span className="no-results-p">No Data</span>
              </>
            }
          ></Empty>
        )}
      </Collapse>
      <Pagination
        showSizeChanger={false}
        id="main-obligations-pagination"
        current={currentPage}
        pageSize={5}
        total={obligationsInCategory && obligationsInCategory.length}
        onChange={handlePageChange}
      />
    </div>
  );
};

export default MainObligations;
